import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a553771"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-bottom":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增广告项")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("注意：下面的每个保存表示保存当前广告项，不是保存全部")
const _hoisted_4 = { class: "item_list_box" }
const _hoisted_5 = { class: "helper" }
const _hoisted_6 = { style: {"margin-bottom":"20px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_img_uploader = _resolveComponent("img-uploader")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "广告项列表",
    width: 800,
    "before-close": _ctx.dialogHandle.close,
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              disabled: _ctx.AbleAddAdItem,
              type: "primary",
              onClick: _ctx.dialogHandle.pushItem
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_el_button, { type: "text" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogHandle.itemList, (ad, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: ad.rid,
              class: "form_item"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_form_item, {
                  label: "文字",
                  prop: "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: ad.title,
                      "onUpdate:modelValue": ($event: any) => ((ad.title) = $event),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_form_item, {
                  label: "链接",
                  prop: "url"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: ad.url,
                      "onUpdate:modelValue": ($event: any) => ((ad.url) = $event),
                      placeholder: "请输入"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                (_ctx.type !== 2)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "图片",
                      prop: "img",
                      "show-message": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_img_uploader, {
                          "show-img": ad.img,
                          onFileInfo: ($event: any) => (_ctx.dialogHandle.handleImg($event, index))
                        }, null, 8, ["show-img", "onFileInfo"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    icon: _ctx.deleteIcon,
                    circle: "",
                    onClick: ($event: any) => (_ctx.dialogHandle.delItem(index))
                  }, null, 8, ["icon", "onClick"])
                ]),
                _createElementVNode("span", null, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (_ctx.dialogHandle.submit(index))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["before-close"]))
}